"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.specifiedIllnessDogBase = exports.specifiedIllnessDefaultDogList = exports.specifiedIllnessDefaultCatList = exports.specifiedIllnessCatBase = exports["default"] = void 0;
var specifiedIllnessDogBase = exports.specifiedIllnessDogBase = {
  "default": {
    header: {
      title: 'Specified Illness',
      subtitle: 'means a sickness or disease that is a consequence of or results in one of the following:'
    }
  }
};
var specifiedIllnessDefaultDogList = exports.specifiedIllnessDefaultDogList = {
  separators: {
    base: ';',
    secondLast: '; or',
    last: '.'
  },
  style: 'unordered',
  type: 'disc',
  listItems: ['tick paralysis', 'heat stroke', 'gastric dilatation-volvulus (GDV)', 'Trauma induced respiratory impairment (for example, if your Pet chokes or experiences near-drowning)', 'traumatic spinal disc rupture', 'torn nail', 'embedded grass seed', 'soft tissue injury', 'eye Trauma']
};
var specifiedIllnessCatBase = exports.specifiedIllnessCatBase = {
  "default": {
    header: {
      title: 'Specified Illness',
      subtitle: 'means a sickness or disease that is a consequence of or results in one of the following:'
    }
  }
};
var specifiedIllnessDefaultCatList = exports.specifiedIllnessDefaultCatList = {
  separators: {
    base: ';',
    secondLast: '; or',
    last: '.'
  },
  style: 'unordered',
  type: 'disc',
  listItems: ['cancer', 'feline lower urinary tract disease', 'Gastrointestinal Problems', 'diabetes', 'hyperthyroidism', 'heart disease', 'outer and inner ear infection', 'arthritis', 'renal disease']
};
var _default = exports["default"] = {
  specifiedIllnessCatBase: specifiedIllnessCatBase,
  specifiedIllnessDefaultCatList: specifiedIllnessDefaultCatList,
  specifiedIllnessDogBase: specifiedIllnessDogBase,
  specifiedIllnessDefaultDogList: specifiedIllnessDefaultDogList
};